import ChangeTeamManager from './ChangeTeamManager';

export default ChangeTeamManager;
